class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.header');
    this.mobileMenu = this.querySelector('.mobile-menu');
    this.menuToggle = this.querySelector('.header__menu-toggle');
    this.menuClose = this.querySelector('.mobile-menu__close');
    this.dropdownButtons = this.querySelectorAll('.has-dropdown > .header__nav-link');
    this.overlay = document.getElementById('overlay');
  }

  connectedCallback() {
    if (this.classList.contains('header--sticky')) {
      this.setupStickyObserver();
    }
    this.setupMobileMenu();
    this.setupDropdowns();
  }

  setupStickyObserver() {
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;height:1px;width:1px;pointer-events:none;';
    this.parentNode.insertBefore(sentinel, this);

    const observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-scrolled', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  setupMobileMenu() {
    if (!this.menuToggle || !this.mobileMenu) return;

    this.menuToggle.addEventListener('click', () => this.openMobileMenu());
    this.menuClose?.addEventListener('click', () => this.closeMobileMenu());
    this.overlay?.addEventListener('click', () => this.closeMobileMenu());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.mobileMenu.classList.contains('is-open')) {
        this.closeMobileMenu();
      }
    });
  }

  openMobileMenu() {
    this.mobileMenu.classList.add('is-open');
    this.mobileMenu.setAttribute('aria-hidden', 'false');
    this.menuToggle.setAttribute('aria-expanded', 'true');
    this.overlay?.classList.add('is-active');
    document.documentElement.classList.add('no-scroll');
    this.menuClose?.focus();
  }

  closeMobileMenu() {
    this.mobileMenu.classList.remove('is-open');
    this.mobileMenu.setAttribute('aria-hidden', 'true');
    this.menuToggle.setAttribute('aria-expanded', 'false');
    this.overlay?.classList.remove('is-active');
    document.documentElement.classList.remove('no-scroll');
    this.menuToggle.focus();
  }

  setupDropdowns() {
    this.dropdownButtons.forEach((btn) => {
      const item = btn.parentElement;

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-active');
        this.closeAllDropdowns();
        if (!isOpen) {
          item.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          item.classList.remove('is-active');
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.has-dropdown')) {
        this.closeAllDropdowns();
      }
    });
  }

  closeAllDropdowns() {
    this.querySelectorAll('.has-dropdown.is-active').forEach((item) => {
      item.classList.remove('is-active');
      item.querySelector('.header__nav-link')?.setAttribute('aria-expanded', 'false');
    });
  }
}

customElements.define('sticky-header', StickyHeader);
